import React from "react";
interface Article {
  icon: string;
  category: string;
  title: string;
  description: string;
  readingTime: string;
  href?: string;
}

interface ArticlesSectionProps {
  eyebrow?: string;
  title?: string;
  ctaLabel?: string;
  ctaHref?: string;
  articles?: Article[];
}

const defaultArticles: Article[] = [
  {
    icon: "📖",
    category: "Médecine prophétique",
    title: "Comprendre la Hijama : pratique, précautions et déroulement",
    description:
      "Une présentation claire de la Hijama, de ses usages traditionnels et des précautions à connaître avant une séance.",
    readingTime: "5 min de lecture",
    href: "#",
  },
  {
    icon: "🌿",
    category: "Phytothérapie responsable",
    title: "La nigelle : vertus, usages et précautions à connaître",
    description:
      "Retour sur les propriétés de la graine de nigelle, plante bénie mentionnée dans la tradition prophétique.",
    readingTime: "4 min de lecture",
    href: "#",
  },
  {
    icon: "💙",
    category: "Corps, cœur & état intérieur",
    title: "Fatigue chronique : quand chercher des causes au-delà du médical ?",
    description:
      "Comprendre les liens entre fatigue, habitudes de vie, alimentation et bien-être global.",
    readingTime: "6 min de lecture",
    href: "#",
  },
];

const ArticlesSection: React.FC<ArticlesSectionProps> = ({
  eyebrow = "Conseils & ressources",
  title = "Mieux comprendre pour mieux prendre soin de soi",
  ctaLabel = "Voir tous les conseils",
  ctaHref = "#",
  articles = defaultArticles,
}) => {
  return (
    <section className="articles-section py-5 py-lg-6">
      <div className="container-xl">
        <div className="row align-items-end mb-5 gy-3">
          <div className="col-12 col-lg-9">
            <p className="articles-eyebrow mb-2">{eyebrow}</p>
            <h2 className="articles-title mb-0">{title}</h2>
          </div>
          <div className="col-12 col-lg-3 text-lg-end">
            <a href={ctaHref} className="articles-cta">
              {ctaLabel} <span className="articles-cta-arrow">→</span>
            </a>
          </div>
        </div>

        <div className="row g-4">
          {articles.map((article, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-4">
              <a href={article.href} className="article-card h-100">
                <div className="article-thumb">
                  <span className="article-icon">{article.icon}</span>
                </div>
                <div className="article-body p-4">
                  <p className="article-category mb-2">{article.category}</p>
                  <h3 className="article-title mb-2">{article.title}</h3>
                  <p className="article-description mb-3">
                    {article.description}
                  </p>
                  <p className="article-meta mb-0">
                    <span className="article-meta-icon">🕒</span>
                    {article.readingTime}
                  </p>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ArticlesSection;